import { Col, Input, Row } from 'antd'
import React from 'react'
import { ContentInputField } from '../../../../components/atoms/formFields/inputField/contentInputField';
import { ContentTextArea } from '../../../../components/atoms/formFields/textArea';

const GstPan = ({ gstPan, storeObject, setStoreObject, errors, setErrors, GSTregex, PANregex }) => {
    const renderDocumentSection = (data = [], type = "GST") =>
        data?.map((obj, i) => (
            <React.Fragment key={`${type}-${i}`}>
                <Col className="gutter-row" xs={24} lg={6}>
                    <ContentInputField
                        name={`${type} Number`}
                        className="form-control"
                        value={obj?.number}
                        disabled
                    />
                </Col>
                <Col className="gutter-row" xs={24} lg={2}>
                    <label className="font-weight-bolder font-size-sm">Status</label>
                    <div>
                        <span
                            className={`p-1 px-2 text-white rounded font-size-lg d-inline-block mb-2 ${obj?.status === "APPROVED"
                                ? "bg-primary"
                                : obj?.status === "PENDING"
                                    ? "bg-warning"
                                    : obj?.status === "REJECTED"
                                        ? "bg-gray-800"
                                        : "bg-danger"
                                }`}
                        >
                            {obj?.status}
                        </span>
                    </div>
                </Col>
                <Col className="gutter-row pr-0 pl-4 ml-5" xs={24} lg={3}>
                    <label className="font-weight-bolder font-size-sm">{type} Document</label>
                    <div className="imgPreview mt-0 mx-0 mw-100">
                        <a href={obj?.doc?.fileKey} className="document_file" target="_blank" rel="noopener noreferrer">
                            <i className="align-items-center d-flex fa-file-download fas h-75px icon-3x justify-content-center m-2 text-muted" />
                        </a>
                    </div>
                    <small className="text-danger"></small>
                </Col>
            </React.Fragment>
        ));

    const renderInputSection = (type, storeKey, regex, errors, storeObject, setStoreObject, setErrors) => (
        <>
            <Col className="gutter-row" xs={24} lg={6}>
                <ContentInputField
                    name={`${type} Number`}
                    required={true}
                    errors={errors?.[`${storeKey}Number`]}
                    value={storeObject?.[`${storeKey}Number`]}
                    style={{ width: "100%" }}
                    onChange={(e) => {
                        const value = e.target.value;
                        setStoreObject({ ...storeObject, [`${storeKey}Number`]: value });
                        setErrors({
                            ...errors,
                            [`${storeKey}Number`]: value
                                ? regex.test(value)
                                    ? ""
                                    : `Invalid ${type} Number`
                                : storeObject?.gstFileKey || storeObject?.panFileKey
                                    ? ""
                                    : `${type} Number is Mandatory`,
                        });
                    }}
                />
            </Col>
            <Col className="gutter-row" xs={24} lg={5}>
                <label className="font-weight-bolder font-size-sm">{type} Document</label>
                <Input
                    type="file"
                    className={errors?.[`${storeKey}Doc`] ? "invalid" : ""}
                    style={{ width: "100%" }}
                    onChange={(e) => {
                        const file = e.target.files[0];
                        setStoreObject({
                            ...storeObject,
                            [`${storeKey}Doc`]: { file, fileType: "FILE" },
                        });
                        setErrors({
                            ...errors,
                            [`${storeKey}Doc`]: type === "GST" ? (file
                                ? ""
                                : storeObject?.gstFileKey || storeObject?.panFileKey || !storeObject?.[`${storeKey}Number`]
                                    ? ""
                                    : `${type} Document is Mandatory`) : "",
                        });
                    }}
                />
                <small className="text-danger">{errors?.[`${storeKey}Doc`]}</small>
            </Col>
        </>
    );

    // Inside your render/return
    {
        ["rejected", "deleted"].map((status) =>
            (gstPan?.[`${status}GST`]?.length || gstPan?.[`${status}PAN`]?.length) ? (
                <div className="my-7 repeat_div" key={status}>
                    <div className="row m-0">
                        {renderDocumentSection(gstPan?.[`${status}GST`], "GST")}
                        {renderDocumentSection(gstPan?.[`${status}PAN`], "PAN")}
                    </div>
                </div>
            ) : null
        )
    }
    return (
        <Row gutter={[12, 5]} id="ant_inputs">
            <Col className="gutter-row" xs={24} lg={24}>
                <div className="d-flex">
                    <p className="font-weight-bolder font-size-lg mb-3 h5">
                        GST/PAN<span className="text-danger">*</span>
                    </p>
                </div>

                <div className="my-7">
                    {
                        ["rejected", "deleted"].map((status) =>
                            (gstPan?.[`${status}GST`]?.length || gstPan?.[`${status}PAN`]?.length) ? (
                                <div className="my-7 repeat_div" key={status}>
                                    <div className="row m-0">
                                        {renderDocumentSection(gstPan?.[`${status}GST`], "GST")}
                                        {renderDocumentSection(gstPan?.[`${status}PAN`], "PAN")}
                                    </div>
                                </div>
                            ) : null
                        )
                    }
                    <div className="row m-0">
                        {storeObject?.gstFileKey ? (
                            renderDocumentSection([{ number: storeObject.gstNumber, status: storeObject.gstStatus, doc: { fileKey: storeObject.gstDocKey } }], "GST")
                        ) : (
                            renderInputSection("GST", "gst", GSTregex, errors, storeObject, setStoreObject, setErrors)
                        )}

                        <Col className="text-muted gutter-row mt-10 text-center" xs={2} lg={1}>
                            and
                        </Col>

                        {storeObject?.defaultPanNumber ? (
                            renderDocumentSection([{ number: storeObject.panNumber, status: storeObject.panStatus, doc: { fileKey: storeObject.panDocKey } }], "PAN")
                        ) : (
                            renderInputSection("PAN", "pan", PANregex, errors, storeObject, setStoreObject, setErrors)
                        )}

                        <ContentTextArea
                            name="GST Address"
                            value={storeObject?.gstAddress?.en}
                            onChange={(e) => {
                                setStoreObject({
                                    ...storeObject,
                                    gstAddress: {
                                        en: e.target.value
                                    }
                                })
                                setErrors({
                                    ...errors,
                                    gstAddress: e.target.value ? "" : "GST Address is Mandatory",
                                })
                            }

                            }
                            rows={3}
                            required={true}
                            error={errors?.gstAddress}
                        />

                        <p className="ml-2 mt-2 text-muted">
                            Please verify the Vendor GST at{" "}
                            <a href="https://services.gst.gov.in/services/searchtp" target="_blank" rel="noreferrer">
                                Goods & Services Tax (GST)
                            </a>{" "}
                            | Services and approve/reject the GST accordingly
                        </p>
                    </div>
                </div>

            </Col>
        </Row>
    )
}

export default GstPan